/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-confusing-arrow */
/* eslint-disable max-len */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react/jsx-closing-tag-location */
import React from 'react';
import { useSelector } from 'react-redux';
import {
  Route,
  Navigate,
  Routes,
  useLocation,
  useMatch
} from 'react-router-dom';
import Iframe from '../component/ResultView/Iframe/Iframe';
import { getUserDataFromLocal } from '../shared/utility/helper';
import Login from '../views/auth/login/Login.view';
import DirectIframe from '../views/DirectIframe/DirectIframe';
import Layout from '../views/Layout/Layout';

const ProtectedRoute = ({ Component, ...props }) => {
  const authenticated = useSelector((state) => state.loginData.authenticated);
  const userData = getUserDataFromLocal();
  const match = useMatch(props?.path);
  const location = useLocation();

  // if (Component === Login) {
  //   return (
  //     <Route
  //       {...props}
  //       element={(props) => (
  //         <>
  //           {userData?.token || authenticated ? (
  //             <Navigate to='/home/Dashboard/Active-WO-Summary' />
  //           ) : (
  //             <Component {...props} />
  //           )}
  //         </>
  //       )}
  //     />
  //   );
  // }
  if (Component === Login) {
    return (
      <>
        {userData?.token || authenticated ? (
          <Navigate to='/home/Dashboard/Active-WO-Summary' />
        ) : (
          <Component {...props} />
        )}
      </>
    );
  }

  // return (
  //   <Route
  //     {...props}
  //     element={(props) => <>{userData?.token || authenticated ? <Component {...props} /> : <Navigate to='/' />}</>}
  //   />
  // );

  return (
    <>
      {userData?.token || authenticated ? (
        <Component match={match} location={location} {...props} />
      ) : (
        <Navigate to='/' />
      )}
    </>
  );
};

const HomeRoutes = () => (
  <Routes>
    <Route
      path='/home'
      exact={false}
      name='home'
      element={
        <ProtectedRoute
          path='/home'
          exact={false}
          name='home'
          Component={Layout}
        />
      }
    />
    <Route
      path='/home/*'
      exact={false}
      name='home'
      element={
        <ProtectedRoute
          path='/home'
          exact={false}
          name='home'
          Component={Layout}
        />
      }
    />
    <Route
      path='/filter-iframe'
      exact={false}
      name='iframe'
      element={
        <ProtectedRoute
          path='/filter-iframe'
          exact={false}
          name='iframe'
          Component={Iframe}
        />
      }
    ></Route>
    <Route
      path='/direct-iframe'
      exact={false}
      name='direct-iframe'
      element={
        <ProtectedRoute
          path='/direct-iframe'
          exact={false}
          name='direct-iframe'
          Component={DirectIframe}
        />
      }
    ></Route>
    <Route
      path='/*'
      exact={false}
      name='login'
      element={
        <ProtectedRoute exact={false} name='login' path='/' Component={Login} />
      }
    />
  </Routes>
);

export default HomeRoutes;
